import Select, { SingleValue } from 'react-select';
import { Option } from 'types/global';
import './TextDropdown.scss';
import { useTheme } from '@mui/material';

interface TextDropdownProps {
  label?: string;
  name: string;
  value: SingleValue<Option>;
  onChange: (currentValue: SingleValue<Option>) => void;
  options: Option[];
}

const TextDropdown = ({
  label,
  name,
  value,
  onChange,
  options
}: TextDropdownProps) => {
  const theme = useTheme();
  return (
    <>
      {label && <span className="fw-bold">{label}</span>}
      <Select
        className="text-dropdown"
        classNamePrefix="text-dropdown"
        name={name}
        value={value}
        onChange={value => value && onChange(value)}
        options={options}
        isSearchable={false}
        menuPortalTarget={document.body}
        //not perfect but i couldnt find a way to set z-index, seems miui styles and react styles were conflicting in tss
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          menu: base => ({
            ...base,
            zIndex: 9999,
            '& .text-dropdown__option--is-selected': {
              backgroundColor: theme.palette.primary.main,
              color: 'white ',
              opacity: 0.8
            },
            '& .text-dropdown__option:hover': {
              backgroundColor: theme.palette.primary.main,
              color: 'white',
              opacity: 1
            }
          })
        }}
      />
    </>
  );
};

export default TextDropdown;
